class MultipackBundle extends HTMLElement {
    constructor() {
        super();
        this.querySelectorAll("div.step-js").forEach((stepJs) => {
            stepJs.addEventListener("click", this.handleStepClick);
        });
        this.querySelectorAll(".select-content-multipack-js").forEach(
            (optionInput) => {
                optionInput.addEventListener(
                    "change",
                    this.handleVariantSelection
                );
            }
        );
        this.querySelectorAll(".btn-content-multipack").forEach((btn) => {
            btn.addEventListener("click", this.handleAddProduct);
        });
        this.querySelectorAll(".bundle-clear-selection-text-js").forEach(
            (item) => {
                item.addEventListener("click", this.clearSelections);
            }
        );
        document.querySelectorAll(".bundle-add-to-cart").forEach((btn) => {
            btn.addEventListener("click", (e) => this.handleAddToCart(e, this));
        });
    }

    handleStepClick(e) {
        const el = e.currentTarget;
        const stepIndex = Number(el.dataset.step);
        document.querySelectorAll(".tab-content").forEach((tab) => {
            tab.style.display = "none";
        });
        document.querySelectorAll(".step").forEach((step) => {
            step.classList.remove("active");
        });
        el.classList.add("active");
        document.querySelector(`#contentStep${stepIndex}`).style.display =
            "grid";
    }

    handleVariantSelection(e) {
        const el = e.currentTarget;
        const productId = el.dataset.productId;
        const optionValues = [
            ...document.querySelectorAll(
                `select[data-option-position][data-product-id='${productId}'],input[data-option-position][data-product-id='${productId}']:checked`
            ),
        ].map((item) => {
            return item.value;
        });
        const jsonVariants = [
            ...document.querySelectorAll(
                `.bundle-variant-data-input-${productId}`
            ),
        ].map((item) => JSON.parse(item.dataset.variant));
        const selectedVariant = jsonVariants
            .filter((variant) =>
                optionValues.every(
                    (option, index) => option === variant[`option${index + 1}`]
                )
            )
            .at(-1);
        const addBtn = document.querySelector(
            `.btn-content-multipack-${productId}`
        );
        if (optionValues.length > 1) {
            const arrayOptions = [];
            const optionPosition = el.dataset.optionPosition ?? 0;
            jsonVariants.map((variant) => {
                if (
                    variant["option" + optionPosition] == el.value &&
                    variant.available
                ) {
                    for (let i = 0; i < optionValues.length; i++) {
                        arrayOptions[i] = [
                            ...(arrayOptions[i] ?? []),
                            variant[`option${i + 1}`],
                        ];
                    }
                }
            });
            const trimmedArrayOptions = arrayOptions.map((valuesArray) => {
                return valuesArray.filter((value, index) => {
                    return valuesArray.indexOf(value) === index;
                });
            });
            trimmedArrayOptions.forEach((optionValues, i) => {
                document
                    .querySelectorAll(
                        `.select-content-multipack-${productId}-${i + 1}`
                    )
                    .forEach((option) => {
                        if (option.nodeName == "SELECT") {
                            option
                                .querySelectorAll("option")
                                .forEach((value) => {
                                    if (i + 1 != optionPosition) {
                                        value.disabled = !optionValues.includes(
                                            value.value
                                        );
                                    } else {
                                        value.disabled = false;
                                    }
                                });
                        } else {
                            if (i + 1 != optionPosition) {
                                option.disabled = !optionValues.includes(
                                    option.value
                                );
                            } else {
                                option.disabled = false;
                            }
                        }
                    });
            });
        }
        if (selectedVariant != null && selectedVariant.available) {
            document.querySelector(`.img-content-multipack-${productId}`).src =
                selectedVariant.img;
            addBtn.disabled = false;
            addBtn.innerHTML = "ADD TO BUNDLE";
            addBtn.dataset.variant = JSON.stringify(selectedVariant);
        } else {
            addBtn.disabled = true;
            addBtn.innerHTML = "SOLD OUT";
            addBtn.dataset.variant = null;
        }
    }

    handleAddProduct(e) {
        const el = e.currentTarget;
        const savedAmount = Number(
            document.querySelector("#bundle-saved-amount").value
        );
        const step = Number(el.dataset.step);
        const jsonVariant = JSON.parse(el.dataset.variant);
        const stepContainer = document.querySelector(`#step${step}`);
        const stepMobileContainer = document.querySelector(
            `.step-${step}-review`
        );
        stepContainer.classList.add("step-selected");
        stepMobileContainer.classList.add("step-review-container-completed");
        stepContainer.querySelector(
            ".bundle-step-selected-product-img img"
        ).src = jsonVariant.img;
        stepMobileContainer.querySelector("img").src = jsonVariant.img;
        document.querySelector(`.bundle-builder-sticky-img-${step} img`).src =
            jsonVariant.img;
        document.querySelector(
            `.bundle-builder-sticky-img-${step}`
        ).style.display = "block";
        stepContainer.querySelector(
            ".bundle-step-selected-product"
        ).style.display = "block";
        const variantsArray = JSON.parse(
            document.querySelector(".bundle-add-to-cart").dataset.addToCart
        );
        variantsArray[step - 1] = jsonVariant;
        document.querySelector(".bundle-builder-sticky-header").innerHTML =
            "1 PRODUCT ADDED";
        document.querySelectorAll(".bundle-add-to-cart").forEach((btn) => {
            btn.dataset.addToCart = JSON.stringify(variantsArray);
        });
        const nextStep = document.querySelector(`#step${step + 1}`);
        if (nextStep) {
            nextStep.click();
        } else {
            stepContainer.classList.remove("active");
            document.querySelector(`#contentStep${step}`).style.display =
                "none";
            document
                .querySelector(".bundle-builder-layout-steps")
                .classList.add("hidden-layout-content");
            document.querySelector(
                ".bundle-clear-selection-text"
            ).style.display = "block";
        }
        const isFullVariants = variantsArray.every((value) => value != null);
        if (isFullVariants) {
            document.querySelector(".multipack-section-header").focus();
            let totalPrice = 0;
            let subtotalPrice = 0;
            let savedPrice = 0;
            variantsArray.forEach((value) => {
                totalPrice += Number(value.price);
            });
            subtotalPrice = totalPrice - savedAmount;
            savedPrice = savedAmount;
            document
                .querySelectorAll(".bundle-builder-final-price")
                .forEach((priceContainer) => {
                    priceContainer.innerHTML = formatCurrency(
                        subtotalPrice / 100
                    );
                });
            document
                .querySelectorAll(".bundle-builder-total-price")
                .forEach((priceContainer) => {
                    priceContainer.innerHTML = formatCurrency(totalPrice / 100);
                });
            document
                .querySelectorAll(".bundle-builder-saved-price")
                .forEach((priceContainer) => {
                    priceContainer.innerHTML =
                        "Save " + formatCurrency(savedPrice / 100);
                });
            document.querySelectorAll(".bundle-add-to-cart").forEach((btn) => {
                btn.disabled = false;
                btn.dataset.bundlePrice = subtotalPrice;
            });
        }
        function formatCurrency(value) {
            return value.toLocaleString(
                `${Shopify.locale}-${Shopify.country}`,
                {
                    style: "currency",
                    currency: Shopify.currency.active,
                }
            );
        }
    }

    clearSelections() {
        document.querySelectorAll(".bundle-add-to-cart").forEach((item) => {
            item.disabled = true;
        });
        document.querySelector(".bundle-clear-selection-text").style.display =
            "none";
        document.querySelectorAll(".step").forEach((item) => {
            item.classList.remove("step-selected");
        });
        document.querySelector("#contentStep1").style.display = "block";
        document
            .querySelectorAll(".bundle-step-selected-product")
            .forEach((item) => {
                item.style.display = "none";
            });
        document.querySelectorAll(".bundle-add-to-cart").forEach((item) => {
            item.dataset.addToCart = "[null,null,null]";
        });
        document
            .querySelectorAll(".bundle-builder-layout-steps")
            .forEach((item) => {
                item.classList.remove("hidden-layout-content");
            });
        document.querySelector("#step1").click();
        document.querySelector("#step1").classList.add("active");
        document.querySelectorAll(".step-review-container").forEach((item) => {
            item.classList.remove("step-review-container-completed");
        });
        document
            .querySelectorAll(".bundle-builder-sticky-img-1 img")
            .forEach((item) => {
                item.style.display = "none";
            });
        document
            .querySelectorAll(".bundle-builder-sticky-img-2 img")
            .forEach((item) => {
                item.style.display = "none";
            });
        document
            .querySelectorAll(".bundle-builder-sticky-img-3 img")
            .forEach((item) => {
                item.style.display = "none";
            });
        document
            .querySelectorAll(".bundle-builder-sticky-header")
            .forEach((item) => {
                item.innerHTML = "NO PRODUCTS ADDED";
            });
        document
            .querySelectorAll(".bundle-builder-final-price")
            .forEach((item) => {
                item.innerHTML = "";
            });
        document
            .querySelectorAll(".bundle-builder-total-price")
            .forEach((item) => {
                item.innerHTML = "";
            });
        document
            .querySelectorAll(".bundle-builder-saved-price")
            .forEach((item) => {
                item.innerHTML = "";
            });
    }

    updateCartDrawer() {
        document.querySelector(".js-drawer-open-cart").click();
        document.dispatchEvent(new CustomEvent("cart:build"));
    }

    async handleAddToCart(e, container) {
        const el = e.currentTarget;
        el.classList.add("btn--loading");
        const savedAmount = Number(
            document.querySelector("#bundle-saved-amount").value / 100
        );
        const jsonData = JSON.parse(el.dataset.addToCart);
        const jsonFatherData = JSON.parse(
            document.querySelector("#father-bundle-data").dataset.value
        );
        const formData = { items: [] };
        const rawPrices = jsonData.map((item) => {
            return Number(item.price / 100);
        });
        const _bundleSetup = jsonData.map((item, index) => ({
            id: item.id,
            handle: item.handle,
            price: {
                amount: Number(rawPrices[index]),
                currencyCode: Shopify.currency.active,
            },
            quantity: 1,
        }));
        formData.items.push({
            id: jsonFatherData.id,
            quantity: 1,
            properties: {
                _bundleSetup,
                _savedAmount: {
                    amount: savedAmount,
                    currencyCode: Shopify.currency.active,
                },
            },
        });
        const addToCartResponse = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
        }).then((res) => res.json());

        if (addToCartResponse.items.length) {
            el.classList.remove("btn--loading");
            container.clearSelections();
            container.updateCartDrawer();
        }

        function applyFixedDiscount(arr, discount) {
            // Calcular la suma total del arreglo original
            const totalSum = arr.reduce((acc, val) => acc + val, 0);

            // Verificar si el descuento es mayor que la suma total
            if (discount >= totalSum) {
                throw new Error(
                    "El descuento no puede ser mayor o igual a la suma total del arreglo."
                );
            }

            // Calcular el factor de reducción
            const reductionFactor = (totalSum - discount) / totalSum;

            // Aplicar el factor de reducción a cada elemento del arreglo y redondear a 2 decimales
            const adjustedArr = arr.map(
                (val) => Math.round(val * reductionFactor * 100) / 100
            );

            // Calcular la suma ajustada después del redondeo
            let adjustedSum = adjustedArr.reduce((acc, val) => acc + val, 0);

            // Ajustar los valores para compensar el error de redondeo
            let difference =
                Math.round((totalSum - discount - adjustedSum) * 100) / 100;
            const epsilon = 0.01; // Margen de ajuste

            for (let i = 0; difference !== 0 && i < adjustedArr.length; i++) {
                // Determinar el ajuste necesario
                let adjustment =
                    Math.min(epsilon, Math.abs(difference)) *
                    Math.sign(difference);
                adjustedArr[i] =
                    Math.round((adjustedArr[i] + adjustment) * 100) / 100;

                // Recalcular la diferencia
                adjustedSum = adjustedArr.reduce((acc, val) => acc + val, 0);
                difference =
                    Math.round((totalSum - discount - adjustedSum) * 100) / 100;
            }

            return adjustedArr;
        }
        function makeDecimal(num) {
            return new Decimal(num).toFixed(2);
        }

        function calculate_discounted_prices(child_prices, bundle_price) {
            child_prices = child_prices.map((price) => makeDecimal(price));
            bundle_price = makeDecimal(bundle_price);

            const total_child_price = child_prices.reduce(
                (acc, price) => acc.plus(price),
                new Decimal(0)
            );

            const discount_factor = new Decimal(bundle_price).div(
                total_child_price
            );

            const discounted_prices = [];
            for (let i = 0; i < child_prices.length - 1; i++) {
                discounted_prices.push(
                    Number(
                        new Decimal(child_prices[i])
                            .times(discount_factor)
                            .toFixed(0)
                    )
                );
            }

            discounted_prices.push(
                Number(
                    new Decimal(bundle_price)
                        .minus(
                            discounted_prices.reduce(
                                (acc, price) => acc.plus(price),
                                new Decimal(0)
                            )
                        )
                        .toFixed(2)
                )
            );
            return discounted_prices;
        }
    }
}

customElements.define("main-container-multipack", MultipackBundle);
